export function assignVariableActionDetails() {
  return {
    restrict: 'E',
    template: require('./assign-variable-action-details.directive.html'),
    scope: {
      assignedVariable: "="
    },
    controller: AssignvariableActionDetailsController
  };
}

AssignvariableActionDetailsController.$inject = ['$scope'];
function AssignvariableActionDetailsController($scope) {


}